import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { EscalationPathwayContent } from "@/components/EscalationPathwayContent";

export const Route = createFileRoute("/escalation-pathway")({
  head: () => ({
    meta: [
      {
        title:
          "Escalation Pathway | Compliance & Governance",
      },
      {
        name: "description",
        content:
          "Recovery Trauma™ escalation pathway for flagged issues, risks and safeguarding concerns — the decision points, owners and accountability at each stage.",
      },
      {
        property: "og:title",
        content: "Escalation Pathway — Recovery Trauma™",
      },
      {
        property: "og:description",
        content:
          "Documented escalation pathway with clear decision points and accountability at each stage.",
      },
      { property: "og:type", content: "article" },
      {
        property: "og:url",
        content: "https://recoverytrauma.com/escalation-pathway",
      },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://recoverytrauma.com/escalation-pathway",
      },
    ],
  }),
  component: PublicEscalationPathwayPage,
});

function PublicEscalationPathwayPage() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6">
      <div className="mb-6">
        <Link
          to="/about"
          className="inline-flex items-center gap-2 text-sm font-medium text-foreground/70 hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to About
        </Link>
      </div>

      <EscalationPathwayContent />
    </div>
  );
}
